/**
 * Logic Necessary dynamic Guest Additions and Subtractions
 * Author: Imarc 2019
 */

// Dependencies
import '../polyfills/remove';
import '../polyfills/append';

/**
 * DOM
 */
// Initial Index Tracking
// eslint-disable-next-line no-var
var index = 0;

// Template and container for appending
const guestBlankForm = document.querySelector('.js-guestBlankForm');
const guestContainer = document.querySelector('.js-guestContainer');

// Add guest form button
const addGuestButton = document.querySelector('.js-addGuest');

// Already populated guest forms if present
const guestForms = [...document.querySelectorAll('.js-guestForm')];

// Clone and Remove Template for Later Use
const formTemplate = guestBlankForm ? guestBlankForm.cloneNode(true) : false;
if (guestBlankForm) {
    guestBlankForm.remove();
}

// Update index tracking if guest forms already exist.
index = guestForms.length > 0 ? guestForms.length + 1 : 0;

guestForms.forEach(guestForm => {
    const formCollapseTrigger = guestForm.querySelector('.js-formCollapse');
    const removeFormTrigger = guestForm.querySelector('.js-formRemove');

    formCollapseTrigger.addEventListener('click', collapseClickEvent => {
        collapseClickEvent.preventDefault();
        guestForm.classList.toggle('-collapse');
    });

    removeFormTrigger.addEventListener('click', event => {
        event.preventDefault();
        guestForm.remove();
    });
});

/**
 * Update Name of added Guest
 */
const updateFilledGuests = function organizeGuestForm(forms) {
    forms.forEach(form => {
        const firstName = form.querySelector('.js-firstName').value || '';
        const lastName = form.querySelector('.js-lastName').value || '';
        const guestName = form.querySelector('.js-guestName');

        if (firstName || lastName) {
            guestName.innerHTML = `${firstName} ${lastName}`;
        }

        form.classList.add('-collapse');
    });
};

/**
 * Form population
 */
const guestFormAdd = function populateGuestForm(clickEvent) {
    clickEvent.preventDefault();

    // Update index for new unique form
    index += 1;

    // DOM
    const clonedTemplate = formTemplate.cloneNode(true);
    const namedDomElements = [...clonedTemplate.querySelectorAll('[name]')];
    const labelDomElements = [...clonedTemplate.querySelectorAll('label')];
    const formCollapseTrigger = clonedTemplate.querySelector('.js-formCollapse');
    const removeFormTrigger = clonedTemplate.querySelector('.js-formRemove');
    const formTitle = clonedTemplate.querySelector('.js-guestName');

    const newGuestForms = [...document.querySelectorAll('.js-guestForm')];

    // Update guest names before adding a new guest
    if (newGuestForms.length > 0) {
        updateFilledGuests(newGuestForms);
    }

    clonedTemplate.classList.replace('js-guestBlankForm', 'js-guestForm');

    /**
     * Update name, id and labels
     */
    namedDomElements.forEach(namedDomElement => {
        // eslint-disable-next-line no-param-reassign
        namedDomElement.name = namedDomElement.name.replace('<i>', index);
        // eslint-disable-next-line no-param-reassign
        namedDomElement.id = namedDomElement.id.replace('<i>', index);
    });

    labelDomElements.forEach(labelDomElement => {
        // eslint-disable-next-line no-param-reassign
        labelDomElement.htmlFor = labelDomElement.htmlFor.replace('<i>', index);
    });

    formTitle.id = `guest${index}`;

    /**
     * Make guest form collapsable
     */
    formCollapseTrigger.addEventListener('click', collapseClickEvent => {
        collapseClickEvent.preventDefault();
        clonedTemplate.classList.toggle('-collapse');
    });

    removeFormTrigger.addEventListener('click', event => {
        event.preventDefault();
        clonedTemplate.remove();
    });

    /**
     * Populate new form and scroll to top of it
     */
    guestContainer.append(clonedTemplate);
    window.location.hash = `#${formTitle.id}`;
};

/**
 * Click Event Listener
 */
if (addGuestButton) {
    addGuestButton.addEventListener('click', guestFormAdd);
}
